import { authorizedApi } from './index';

export const debitCardApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    joinDebitCardWaitlist: builder.mutation({
      query: () => ({
        url: `/debit-card`,
        method: 'POST',
      }),
    }),
    getDebitCardWaitlist: builder.query({
      query: () => '/debit-card',
    }),
  }),
  overrideExisting: false,
});

export const {
  useJoinDebitCardWaitlistMutation,
  useGetDebitCardWaitlistQuery,
} = debitCardApi;
